module.exports = "/images/blizzard@3x.png?34f81659a30f8605eef6cb0f9e7f37eb";